import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { PRODUCT, SUPPORT_EMAIL } from '../data/content';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-cream" data-id="element-98" data-mp="9ttjgiucqd2c">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-8" data-id="element-99" data-mp="9wfrskp2gwlm">
        <Reveal className="mx-auto flex max-w-3xl flex-col items-center gap-1.5 rounded-2xl border-2 border-gold bg-white p-3.5 text-center sm:p-5" data-id="element-100" data-mp="eu8tp1jc74g3">
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold" data-id="element-101" data-mp="nu4apmzkpto1">
            <ShieldCheckIcon size={24} className="text-white" data-id="element-102" data-mp="skugh1bwvyj9" />
          </span>
          <h2 id="garantia" className="font-display text-base font-black uppercase leading-tight text-ink sm:text-xl" data-id="element-103" data-mp="smxfgav1l204">
            🛡️ Garantía de Devolución de 30 Días
          </h2>
          <p className="font-display text-sm font-black uppercase text-coral sm:text-lg" data-id="element-104" data-mp="17i4pm4130sbt">
            Tu compra está 100% protegida
          </p>
          <p className="font-body text-[0.78rem] leading-snug text-slate sm:text-[0.84rem]" data-id="element-105" data-mp="25syof3xrs2mi">
            Tendrás 30 días para explorar {PRODUCT} y revisar sus seis tomos,
            ejercicios y bonos. Si consideras que el sistema no es adecuado para
            ti, puedes escribirnos dentro del período establecido para solicitar
            un reembolso de acuerdo con los términos de devolución.
          </p>
          <p className="text-[0.76rem] font-semibold text-ink sm:text-[0.8rem]" data-id="element-106" data-mp="2ohwvt3i39wz8">
            Soporte:{' '}
            <a href={`mailto:${SUPPORT_EMAIL}`} className="text-coral underline underline-offset-2" data-id="element-107" data-mp="2jk3og751uwxd">
              {SUPPORT_EMAIL}
            </a>
          </p>
        </Reveal>
      </div>
    </section>;
}